module.exports = __webpack_public_path__ + "img/emoji_73.a86d1a44.png";